import { useCommitsDaGmud } from '../../../api/queries/repositorios'
import { Esqueleto } from '../../../components/Estados'
import { dataHora } from '../../../lib/datas'
import { TEXTOS } from '../../../lib/glossario'
import { EtiquetaDeSetor } from '../../repositorios/EtiquetaDeSetor'

/** Estados em que a solicitação ainda não tem decisão do comitê. */
const ANTES_DA_DECISAO = new Set(['RASCUNHO', 'SOLICITADA', 'EM_AVALIACAO_CAB', 'AGUARDANDO_AJUSTES'])

/**
 * Os commits da branch principal que citam esta solicitação — o material que o comitê não tinha.
 *
 * A revisão de PR diz o que o Copilot achou do código; esta lista diz o que de fato entrou na
 * branch principal, por quem e quando. Com a solicitação ainda sem decisão, cada commit é código
 * integrado antes da aprovação, e a lista diz isso com todas as letras.
 *
 * @param props a solicitação e o estado dela
 * @returns a lista, dentro do apoio ao comitê
 */
export function CommitsDaGmud({ gmudId, status }: { gmudId: number; status: string }) {
  const t = TEXTOS.repositorios.naGmud
  const { data, isPending } = useCommitsDaGmud(gmudId)
  const antesDaDecisao = ANTES_DA_DECISAO.has(status)

  return (
    <div className="border-t border-slate-200 pt-3">
      <h3 className="text-sm font-medium text-slate-700">{t.titulo}</h3>
      <p className="mt-0.5 text-xs text-slate-500">{t.ajuda}</p>
      {isPending && <Esqueleto linhas={1} />}
      {data && data.length === 0 && <p className="mt-2 text-sm text-slate-500">{t.nenhum}</p>}
      {data && data.length > 0 && (
        <ul className="mt-2 space-y-2">
          {data.map((c) => (
            <li key={c.id} className="rounded-md border border-slate-200 p-3 text-sm">
              <p className="flex flex-wrap items-center gap-2">
                <a
                  href={c.url}
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium text-niteroi-700 underline underline-offset-2 hover:text-niteroi-900"
                >
                  {c.repositorio.nomeCompleto.split('/').pop()}@{c.sha.slice(0, 7)}
                </a>
                <span className="text-slate-600">{dataHora(c.commitEm)}</span>
                {c.integracao && (
                  <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-700">{t.integracao}</span>
                )}
                {antesDaDecisao && !c.integracao && (
                  <span className="rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-900 ring-1 ring-inset ring-amber-200">
                    {TEXTOS.apoioAoComite.mesclado.toLowerCase()} antes da decisão do comitê
                  </span>
                )}
              </p>
              <p className="mt-1 text-slate-800">{c.titulo}</p>
              <p className="mt-1 flex items-center gap-2 text-xs text-slate-500">
                {c.autor.nome}
                <EtiquetaDeSetor setor={c.autor.setor} />
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
